import React, { PropsWithChildren } from 'react';
import { Box, styled } from '@mui/material';
import AccountMenu from 'components/AccountMenu/AccountMenu';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { NavbarItem, TabItem } from 'features/navbar/types';
import { NavList } from '../NavList/NavList';
import { TabletDesktopNavbarContainer } from './TabletDesktopNavbarContainer';
import { NavbarLogo } from './NavbarLogo';

interface DesktopNavbarProps {
  brandLogo: React.ReactElement;
  onBrandLogoClick: () => void;
  selectedTab?: NavbarItem;
  onTabChange: (tabObject: TabItem) => void;
  desktopNavitemList: TabItem[];
  tabletNavitemList: TabItem[];
}

const StyledNavbarLogo = styled(NavbarLogo)(({ theme }) => ({
  paddingLeft: theme.spacing(1.375),
  paddingRight: theme.spacing(1.375),
}));

const LogoSection = styled(Box)<{ isDesktop: boolean }>(({ isDesktop }) => ({
  display: 'flex',
  flex: isDesktop ? 'none' : 1,
  justifyContent: 'flex-start',
}));

const TabsSection = styled(Box)<{ isDesktop: boolean }>(({ isDesktop }) => ({
  display: 'flex',
  flex: isDesktop ? 'auto' : 1,
  justifyContent: isDesktop ? 'flex-start' : 'center',
}));

const AccountSection = styled(Box)<{ isDesktop: boolean }>(({ isDesktop }) => ({
  display: 'flex',
  flex: isDesktop ? 'none' : 1,
  justifyContent: 'flex-end',
}));

export const DesktopTabletNavbar = ({
  brandLogo,
  onBrandLogoClick,
  onTabChange,
  selectedTab,
  desktopNavitemList,
  tabletNavitemList,
}: PropsWithChildren<DesktopNavbarProps>) => {
  const { isDesktop } = useDeviceType();
  const navItemList = isDesktop ? desktopNavitemList : tabletNavitemList;

  return (
    <TabletDesktopNavbarContainer toolbarStyle={{ justifyContent: 'space-between' }}>
      <LogoSection isDesktop={isDesktop}>
        <StyledNavbarLogo brandLogo={brandLogo} onBrandLogoClick={onBrandLogoClick} />
      </LogoSection>
      <TabsSection isDesktop={isDesktop}>
        <NavList
          hideTabIndicator={!isDesktop}
          onTabChange={onTabChange}
          selectedTab={selectedTab}
          navItemList={navItemList}
        />
      </TabsSection>
      <AccountSection isDesktop={isDesktop}>
        <AccountMenu />
      </AccountSection>
    </TabletDesktopNavbarContainer>
  );
};
